import { render, staticRenderFns } from "@/modules/CarrierProduct/templates/carrier-products-list.html?vue&type=template&id=3333292a&scoped=true&"
import script from "@/modules/CarrierProduct/scripts/carrier-products-list.ts?vue&type=script&lang=js&"
export * from "@/modules/CarrierProduct/scripts/carrier-products-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/CarrierProduct/styles/carrier-products-list.scss?vue&type=style&index=0&id=3333292a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3333292a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
